export const comments_5618942 = {"data":{"data":[],"links":{}}}